module.exports = __webpack_public_path__ + "static/media/2_Obrazec_na_pulnomoshtno_20170631.97996b31.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/2_Obrazec_na_pulnomoshtno_20170631.pdf
// module id = 151
// module chunks = 0